<template>
  <modal ref="modal">
    <modal-body class="modal_body" :message="message" />
    <div class="space">
      <div class="modal_date">振込日</div>
      <date-input class="modal_date_input" :class="errorMessage ? 'is-invalid' : ''" :value="modelValue"  @input="doInput" :set-handler="setDateHandler" />
    </div>
    <modal-footer>
      <send-button @click="doSend" />
      <cancel-button type="submit" data-coreui-dismiss="modal" />
    </modal-footer>
  </modal>
</template>

<script>
import Modal from "@/views/atoms/Modal";
import ModalBody from "@/views/atoms/ModalBody";
import ModalFooter from "@/views/atoms/ModalFooter";
import SendButton from '@/views/molecules/buttons/SendButton';
import CancelButton from '@/views/molecules/buttons/CancelButton';
import DateInput from "@/views/atoms/inputs/DateInput.vue";

export default {
  name: "SendConfirmModal",
  components: {
    Modal,
    ModalBody,
    ModalFooter,
    SendButton,
    CancelButton,
    DateInput
  },
  props: {
    message: {
      type: String,
      default: "アップロードが完了しました。\nこのまま送信してよろしいですか？",
    },
     setHandler: {
      type: Function,
      default: () => {
      }
    },
    modelValue: {  // modelValue を追加
      type: [String, Date, null],
      default: null
    },
    errorMessage: {
      type: String,
      default: '',
    },
  },
  emits: ['send','update:modelValue','inputValue'],
  methods: {
    show() {
      this.$refs.modal.show();
    },
    doSend() {
      this.$refs.modal.hide();
      this.$emit('send');
    },
    setDateHandler(payload) {
      this.$emit('update:modelValue', payload.value);
    },
    doInput(event){
      this.$emit('inputValue',event.target.value);
    }
  },
}
</script>
<style scoped>
.space {
  width: 20rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0rem 1rem 1.5rem; /* ← 上に軽く余白 */
}
.modal_date_input {
  width: 10rem;
}
.modal_body {
  /* 安全に詰めたい場合は padding-bottom で調整 */
  padding-bottom: 0.25rem;
  line-height: 1.4;
}
</style>